import Vue from "@/libraries/vue";
import Comment from "@/components/Comment.vue";
export default Vue.extend({
    name: "Comment",
    components: {
        Comment,
    },
    props: {
        comment: Object,
        isEven: Boolean,
    },
    computed: {
        author() {
            const comment = this.comment;
            return (comment && comment.author) || "";
        },
        author_link() {
            const comment = this.comment;
            return (comment && comment.author_link) || "";
        },
        score() {
            const comment = this.comment;
            return (comment && comment.score) || "";
        },
        permalink() {
            const comment = this.comment;
            return (comment && comment.permalink) || "";
        },
        subreddit() {
            const comment = this.comment;
            return (comment && comment.subreddit) || "";
        },
        created() {
            const comment = this.comment;
            return (comment && parseDate(comment.created_utc)) || "";
        },
        body_html() {
            const comment = this.comment;
            return (comment && decode(comment.body_html)) || "";
        },
        thread() {
            const comment = this.comment;
            return (comment && comment.thread) || "";
        },
        replies() {
            const comment = this.comment;
            return ((comment && comment.replies && comment.replies.data.children) || "");
        },
    },
});
export function decode(html) {
    if (!html)
        return "";
    if ("undefined" == typeof document)
        return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}
export function parseDate(unix) {
    const now = new Date().getTime() / 1000;
    if (!unix || unix > now)
        return "";
    const seconds = now - unix;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days === 1)
        return "1 day ago";
    if (days > 0)
        return days + " days ago";
    if (hours === 1)
        return "1 hour ago";
    if (hours > 0)
        return hours + " hours ago";
    if (minutes === 1)
        return "1 minute ago";
    if (minutes > 0)
        return minutes + " minutes ago";
    return "a few seconds ago";
}
